// =====================================================
// 📁 components/QuotationViewTotals.tsx
// =====================================================

import React from 'react';
import { formatCurrency } from '../../../../../../utils/formatCurrency';


interface Props {
  quotation: any;
}

const QuotationViewTotals: React.FC<Props> = ({ quotation }) => {
  return (
    <div
      className="
        ml-auto w-full max-w-md
        rounded-sm border border-stroke
        bg-white shadow-default
        dark:border-strokedark
        dark:bg-boxdark
      "
    >
      {/* Header */}
      <div
        className="
          border-b border-stroke
          px-5 py-4
          dark:border-strokedark
        "
      >
        <h3
          className="
            text-base font-semibold
            text-black dark:text-white
          "
        >
          Resumen Totales
        </h3>
      </div>

      {/* Body */}
      <div className="p-5">
        <div className="space-y-3">
          {/* Desc Items */}
          <div
            className="
              flex items-center justify-between
            "
          >
            <span
              className="
                text-sm text-bodydark2
              "
            >
              Descuento Items
            </span>

            <span
              className="
                font-medium
                text-black dark:text-white
              "
            >
              ${formatCurrency(quotation.itemsDiscountTotal)}
            </span>
          </div>

          {/* Desc Global */}
          <div
            className="
              flex items-center justify-between
            "
          >
            <span
              className="
                text-sm text-bodydark2
              "
            >
              Descuento Global
            </span>

            <span
              className="
                inline-flex rounded-sm
                bg-warning bg-opacity-10
                px-2 py-1 text-xs
                font-medium text-warning
              "
            >
              {quotation.globalDiscountPercent}%
            </span>
          </div>

          {/* Monto Desc */}
          <div
            className="
              flex items-center justify-between
            "
          >
            <span
              className="
                text-sm text-bodydark2
              "
            >
              Monto Descuento
            </span>

            <span
              className="
                font-medium text-danger
              "
            >
              - ${formatCurrency(quotation.globalDiscountAmount)}
            </span>
          </div>

          {/* Total */}
          <div
            className="
              mt-5 border-t border-stroke
              pt-4 dark:border-strokedark
            "
          >
            <div
              className="
                flex items-center
                justify-between
              "
            >
              <span
                className="
                  text-lg font-semibold
                  text-black dark:text-white
                "
              >
                TOTAL
              </span>

              <span
                className="
                  text-3xl font-bold
                  text-primary
                "
              >
                ${formatCurrency(quotation.total)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuotationViewTotals;
